import { useTLang } from 'intl/intl';

export function useMozartMainDialogLang() {
  return {
    header: {
      title: useTLang({ id: 'notification.mozart.030' }),
    },
    emptyState: {
      title: useTLang({ id: 'notification.mozart.041' }),
      body: useTLang({ id: 'notification.mozart.042' }),
    },
    filterByStore: {
      label: useTLang({ id: 'notification.mozart.004' }),
      labelOfStoreDefault: useTLang({ id: 'notification.mozart.009' }),
    },
  };
}
